import { InnerBeam } from '@cutr/constants/windows/windows-geometry.ts';
import { Line, Rect } from 'react-konva';

import { position } from './colors';
import { MULLION_WIDTH_MM, TRANSOM_WIDTH_MM } from './dimensions';
import { useKonva } from './KonvaContext';

type GridProps = {
  innerBeams: InnerBeam[];
};

export const InnerGrid = ({ innerBeams }: GridProps) => {
  return (
    <>
      {innerBeams.map((innerBeam) => (
        <Beam key={innerBeam.id} innerBeam={innerBeam} />
      ))}
      {innerBeams.map((innerBeam) => (
        <BeamCaps key={innerBeam.id} innerBeam={innerBeam} />
      ))}
    </>
  );
};

type BeamProps = {
  innerBeam: InnerBeam;
};

const Beam = ({ innerBeam }: BeamProps) => {
  const { renderStyles } = useKonva();
  const { x, y, widthMM, heightMM, beamType } = innerBeam;

  if (beamType === 'floating-mullion') {
    return null;
  }

  if (beamType === 'mullion') {
    return (
      <Rect
        x={x - MULLION_WIDTH_MM / 2}
        y={y}
        width={MULLION_WIDTH_MM}
        height={heightMM}
        fill={position.mullion}
        stroke={position.frameStroke}
        strokeWidth={renderStyles.frameStrokeWidthMM}
      />
    );
  }

  if (beamType === 'transom') {
    return (
      <Rect
        x={x}
        y={y - TRANSOM_WIDTH_MM / 2}
        width={widthMM}
        height={TRANSOM_WIDTH_MM}
        fill={position.transom}
        stroke={position.frameStroke}
        strokeWidth={renderStyles.frameStrokeWidthMM}
      />
    );
  }
};

// this is used to mask the top and bottom stroke of the mullion
const BeamCaps = ({ innerBeam }: BeamProps) => {
  const { renderStyles } = useKonva();
  const { x, y, heightMM, beamType } = innerBeam;

  if (beamType === 'mullion') {
    return (
      <>
        <Line
          x={x - MULLION_WIDTH_MM / 2 + renderStyles.frameStrokeWidthMM}
          y={y + heightMM - TRANSOM_WIDTH_MM / 2}
          points={[0, 0, MULLION_WIDTH_MM - renderStyles.frameStrokeWidthMM, 0]}
          stroke={position.frameFill}
          strokeWidth={renderStyles.frameStrokeWidthMM * 2}
        />
      </>
    );
  }

  return null;
};
